import { AuthHelper } from '@/helpers/authHelper'
import { BaseResponseDto } from '@/models/dtos/baseReponseDto'
import { LoginDto } from '@/models/dtos/loginDto'
import { UserInfoDto } from '@/models/dtos/userInfoDto'
import axios from 'axios'
import { Endpoints } from './_endpoints'
import { BehaviorSubject, Observable } from 'rxjs'

export abstract class AuthService {
  static readonly currentUserSubject = new BehaviorSubject(AuthHelper.getuserInfo())

  static async login(loginModel: LoginDto): Promise<boolean> {
    const result = (await axios.post<BaseResponseDto<UserInfoDto>>(Endpoints.login.login, loginModel))

    if (result.status === 200 && result.data && result.data.dto) {
      AuthHelper.setUserInfo(result.data.dto)
      this.currentUserSubject.next(result.data.dto)
      axios.defaults.headers.common.Authorization = `Bearer ${result.data.dto.token}`
      return true
    }

    return false
  }

  static logout(): void {
    AuthHelper.removeUserInfo()
    this.currentUserSubject.next(null)
    delete axios.defaults.headers.common.Authorization
  }

  static currentUser(): Observable<UserInfoDto | null> {
    return this.currentUserSubject
  }

  static get currentUserValue(): UserInfoDto | null {
    return this.currentUserSubject.value
  }
}
